import DDados from '@common/components/addressGlobal/address.ddados';
import api from '@common/components/addressGlobal/service/address.service';
import DDadosItem from '@common/components/ddados/ddados.item';
import React, { Fragment, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import focusHelper from '@common/helpers/focus.helper';
import textUtil from '@common/helpers/text.utils';
import _ from 'lodash';

function AddressBrasil(props) {
  const { Campos } = DDados;
  const {
    name,
    prefix,
    isComplementoNumero,
    isQuadraLote,
    onFocusCep,
    onBlur,
    filterCepBySede,
    numeroObrigatorio,
    serviceInterno,
    obrigatorio,
    disableAll,
  } = props;

  const isView = prefix == 'V';

  const [invalidCEP, setInvalidCep] = useState(false);
  const [Endereco, setEndereco] = useState({});

  // Recebe o state do componente pai
  getDerivedStateFromProps(props);

  // foi criado um controle para pegar atualização do state, sem entrar em loop infinito
  function getDerivedStateFromProps(props) {
    let [prevState, setPrevState] = useState(null);

    if (props.state !== prevState) {
      setPrevState(props.state);
      setEndereco({ ...props.state, UF: props.state?.Uf || props.state?.UF });
    }
  }

  async function onBlurCep(value) {
    try {
      var result;
      var cep = cepIsValid(value);
      if (!disableAll && cep.length == 8) {
        if (cep == Endereco.Cep) return;

        if (serviceInterno) {
          result = await api.getByCepInterno({ data: cep });
        } else {
          result = await api.getByCep({ data: cep, filterCepBySede: filterCepBySede });
        }
        setInvalidCep(false);
        setEndereco({ ...result?.data, Cep: textUtil.maskCep(cepIsValid(result?.data.Cep)), UF: result?.data.Uf });
      } else {
        setEndereco({});
      }
    } catch {
      setInvalidCep(true);
      setEndereco({});
    }

    if (isCepUnico(cep)) {
      focusHelper.focus(`${name}.Tipo`);
    } else focusHelper.focus(`${name}.Numero`);

    onBlur && onBlur({ ...result?.data, Cep: textUtil.maskCep(cepIsValid(result?.data.Cep)), UF: result?.data.Uf });
  }

  function cepIsValid(value) {
    if (!!value) return value.replace(/[_-]/gi, '');
  }

  function isRequiredField(field) {
    if (isView || disableAll) return false;

    return DDados.Campos[field].Obrigatorio;
  }

  function isDisabledField(field) {
    const { Cep } = Endereco;
    const cep = cepIsValid(Cep);

    // não desabilita campos se CEP for inválido
    if (disableAll || invalidCEP) return true;

    // desabilita campos quando CEP for valido
    if (!!cep && (field === 'Numero' || field === 'Complemento')) return false;

    // desabilita campos quando CEP for valido e ComplementoNumero habilitado
    if (!!cep && isComplementoNumero && field === 'ComplementoNumero') return false;

    // desabilita campos quando CEP for valido e QuadraLote habilitado
    if (!!cep && isQuadraLote && (field === 'Quadra' || field === 'Lote')) return false;

    // desabilita campos CEP Unico
    if (isCepUnico(cep) && (field === 'Bairro' || field === 'Tipo' || field === 'Logradouro')) return false;

    return DDados.Campos[field].Desabilitado;
  }

  function isCepUnico(cep) {
    return cep && cep.substr(5) === '000';
  }

  function onBlurEndereco(value) {
    if (!!value) {
      let enderecoNew = {
        ...Endereco,
        ...value,
      };

      setEndereco(enderecoNew);
      onBlur && onBlur(enderecoNew);
    }
  }

  return (
    <Fragment>
      <Row>
        <Col sm="2">
          <DDadosItem
            {...Campos.Cep}
            name={name + '.Cep'}
            state={Endereco}
            stateName="Cep"
            onBlur={onBlurCep}
            isView={isView || disableAll}
            onFocus={onFocusCep}
            Obrigatorio={obrigatorio ?? isRequiredField('Cep')}
          />
        </Col>
        <Col sm="2">
          <DDadosItem
            {...Campos.Tipo}
            name={name + '.Tipo'}
            state={Endereco}
            stateName="Tipo"
            service={api.suggestionTipo}
            mapItem={(item) => ({ ...item, Exibicao: `${item.TipoLogradouro}` })}
            isView={isView}
            onChange={(value) => onBlurEndereco({ Tipo: value && value.TipoLogradouro })}
            Desabilitado={isDisabledField('Tipo')}
            Obrigatorio={obrigatorio ?? isRequiredField('Tipo')}
          />
        </Col>
        <Col sm="8">
          <DDadosItem
            {...Campos.Logradouro}
            name={name + '.Logradouro'}
            stateName="Logradouro"
            service={api.suggestionLogradouro}
            parameters={{
              cep: Endereco?.Cep,
              uf: Endereco?.UF,
              cidade: Endereco?.Cidade,
              bairro: Endereco?.Bairro,
            }}
            mapItem={(item) => ({ ...item, Exibicao: `${item.Logradouro} - ${item.Bairro}` })}
            state={Endereco}
            editavel={true}
            isView={isView}
            onChange={(value) => {
              onBlurEndereco({
                Cep: (value && cepIsValid(value.CEP)) || Endereco.Cep,
                UF: (value && value.UF) || Endereco.UF,
                Cidade: (value && value.Cidade) || Endereco.Cidade,
                Logradouro: (value && value.Logradouro) || value,
                Tipo: (value && value.Tipo) || Endereco.Tipo,
                Bairro: (value && value.Bairro) || Endereco.Bairro,
              });
            }}
            Desabilitado={isDisabledField('Logradouro')}
            Obrigatorio={obrigatorio ?? isRequiredField('Logradouro')}
          />
        </Col>
      </Row>
      <Fragment>
        <Row>
          <Col sm="2">
            <DDadosItem
              name={name + '.Numero'}
              stateName="Numero"
              {...Campos.Numero}
              state={Endereco}
              isView={isView}
              onChange={(value) => onBlurEndereco({ Numero: value })}
              Desabilitado={isDisabledField('Numero')}
              Obrigatorio={numeroObrigatorio ?? isRequiredField('Numero')}
            />
          </Col>
          {!!isComplementoNumero && (
            <Col sm="2">
              <DDadosItem
                name={name + '.ComplementoNumero'}
                stateName="ComplementoNumero"
                {...Campos.ComplementoNumero}
                state={Endereco}
                isView={isView}
                onChange={(value) => onBlurEndereco({ ComplementoNumero: value })}
                Desabilitado={isDisabledField('ComplementoNumero')}
                Obrigatorio={isRequiredField('ComplementoNumero')}
              />
            </Col>
          )}
          {!!isQuadraLote && (
            <>
              <Col sm="2">
                <DDadosItem
                  name={name + '.Quadra'}
                  stateName="Quadra"
                  {...Campos.Quadra}
                  state={Endereco}
                  isView={isView}
                  onChange={(value) => onBlurEndereco({ Quadra: value })}
                  Desabilitado={isDisabledField('Quadra')}
                  Obrigatorio={isRequiredField('Quadra')}
                />
              </Col>
              <Col sm="2">
                <DDadosItem
                  name={name + '.Lote'}
                  stateName="Lote"
                  {...Campos.Lote}
                  state={Endereco}
                  isView={isView}
                  onChange={(value) => onBlurEndereco({ Lote: value })}
                  Desabilitado={isDisabledField('Lote')}
                  Obrigatorio={isRequiredField('Lote')}
                />
              </Col>
            </>
          )}
          <Col sm={!!isComplementoNumero ? '8' : !!isQuadraLote ? '6' : '10'}>
            <DDadosItem
              name={name + '.Complemento'}
              stateName="Complemento"
              {...(props.Campos?.Complemento || Campos.Complemento)}
              state={Endereco}
              isView={isView}
              onChange={(value) => onBlurEndereco({ Complemento: value })}
              Desabilitado={isDisabledField('Complemento')}
              Obrigatorio={isRequiredField('Complemento')}
            />
          </Col>
        </Row>
      </Fragment>
      <Row>
        <Col sm="5">
          <DDadosItem
            {...Campos.Bairro}
            name={name + '.Bairro'}
            stateName="Bairro"
            service={api.suggestionBairro}
            parameters={{
              cep: Endereco?.Cep,
              uf: Endereco?.UF,
              cidade: Endereco?.Cidade,
              logradouro: Endereco?.Logradouro,
            }}
            mapItem={(item) => ({ ...item, Exibicao: `${item.Bairro}` })}
            state={Endereco}
            editavel={true}
            isView={isView}
            onChange={(value) => onBlurEndereco({ Bairro: (value && value.Bairro) || value })}
            Desabilitado={isDisabledField('Bairro')}
            Obrigatorio={obrigatorio ?? isRequiredField('Bairro')}
          />
        </Col>
        <Col sm="5">
          <DDadosItem
            {...Campos.Cidade}
            name={name + '.Cidade'}
            stateName="Cidade"
            service={api.suggestionCidade}
            parameters={{ uf: Endereco?.UF }}
            mapItem={(item) => ({ ...item, Exibicao: `${item.Cidade} - ${item.UF}` })}
            state={Endereco}
            isView={isView}
            onChange={(value) => {
              onBlurEndereco({
                UF: (value && value.UF) || Endereco.UF,
                Cidade: (value && value.Cidade) || value,
              });
            }}
            Obrigatorio={obrigatorio ?? isRequiredField('Cidade')}
          />
        </Col>
        <Col sm="2">
          <DDadosItem
            {...Campos.UF}
            name={name + '.UF'}
            state={Endereco}
            stateName="UF"
            isView={isView}
            onChange={(value) => onBlurEndereco({ UF: value })}
            Obrigatorio={obrigatorio ?? isRequiredField('UF')}
          />
        </Col>
      </Row>
    </Fragment>
  );
}

export default AddressBrasil;
